export const FETCH_REPORTS = "FETCH_REPORTS";
export const FETCH_USER_REPORTS = "FETCH_USER_REPORTS";
export const GET_REPORT = "GET_REPORT";
export const DELETE_USER_REPORT = "DELETE_USER_REPORT";
